module.exports = __webpack_public_path__ + "img/keys.c355cb64.png";